export default __webpack_public_path__ + "static/media/visa.561d24d4.png";